import * as types from '../mutation-types'

const state = {
  query: null,
  filters: {}
}

const getters = {
  getLastQuery: (state) => () => {
    return state.query
  }
}

const actions = {
  saveQuery ({ commit }, { query }) {
    commit(types.UPDATE_SEARCH_ENGINE_QUERY, query)
  }
}

const mutations = {
  [types.UPDATE_SEARCH_ENGINE_QUERY] (state, query) {
    state.query = query
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
